import { render, staticRenderFns } from "./ModalCadastroCursoDocumento.vue?vue&type=template&id=16edd96a"
import script from "./ModalCadastroCursoDocumento.vue?vue&type=script&lang=js"
export * from "./ModalCadastroCursoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports